import * as SC from '@components/common/dropdown/Dropdown.style';
import type { CSSProperties, ReactNode } from 'react';
import Icon from '@components/common/Icon';

type Props<T extends { key: string; label: string }> = {
  wrapperStyle?: CSSProperties;
  selected: T;
  hasArrow?: boolean;
  open: boolean;
  onClick: () => void;
  children?: ReactNode;
  items: T[];
  onClickList: (item: T) => void;
};

function Dropdown<T extends { key: string; label: string }>({
  wrapperStyle,
  selected,
  hasArrow,
  open,
  onClick,
  items,
  onClickList,
}: Props<T>) {
  return (
    <SC.Wrapper style={wrapperStyle} onClick={onClick} open={open}>
      <SC.SelectedText>{selected.label}</SC.SelectedText>
      {hasArrow && (
        <SC.ArrowWrapper open={open}>
          <Icon icon='IconXsUpArrowSolid' color='grey' />
        </SC.ArrowWrapper>
      )}
      {open && (
        <SC.DropdownUl>
          {items.map((item) => (
            <SC.DropdownListWrapper
              onClick={() => {
                onClickList(item);
              }}
              selected={item.key === selected.key}
              key={item.key}
            >
              <SC.DropdownListLabel>{item.label}</SC.DropdownListLabel>
            </SC.DropdownListWrapper>
          ))}
        </SC.DropdownUl>
      )}
    </SC.Wrapper>
  );
}

export default Dropdown;
